var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.89543 2 8 2.89543 8 4V9.5H11C12.933 9.5 14.5 11.067 14.5 13V21C14.5 21.0844 14.4958 21.1678 14.4877 21.25H12.9685C12.9891 21.1701 13 21.0863 13 21V13C13 11.8954 12.1046 11 11 11H4C2.89543 11 2 11.8954 2 13V21C2 21.0863 2.01094 21.1701 2.0315 21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25V4C22 2.89543 21.1046 2 20 2H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAlt2);
export default __webpack_public_path__ + "static/media/house-alt-2.cab4ddf0e4bd58783d84f6ec67e56c6f.svg";
export { ForwardRef as ReactComponent };